import { NativeQSenseControlPlugin } from '@/plugins/NativeQSenseControl';
import { QSenseHubControlPlugin } from '@/plugins/QSenseHubControl';

import { MovementType } from '@/types/MovementTypes';

import { IAnnotationService } from '../interfaces/IAnnotationService';
import { ICalibrationService } from '../interfaces/ICalibrationService';
import { IEventDispatcher } from '../interfaces/IEventDispatcher';
import { ISensorsManagement } from '../interfaces/ISensorsManagement';
import { AnnotationService } from './AnnotationService';

export class CalibrationService implements ICalibrationService {
  private annotations: IAnnotationService;

  constructor(
    plugin: NativeQSenseControlPlugin | QSenseHubControlPlugin,
    private sensors: ISensorsManagement,
    private events: IEventDispatcher,
  ) {
    this.annotations = new AnnotationService(plugin);
  }

  async start(count: number): Promise<void> {
    // Create the annotation and start streaming
    await this.annotations.annotate(MovementType.calibration, count);

    // Reset the movement history of the sensors
    this.sensors.resetMovementHistory();
  }

  async stop(): Promise<void> {
    // Create the annotation for the hub
    await this.annotations.annotate(MovementType.idle, 0);

    // Emit the calibration finished event
    this.events.emit('calibrationFinished');
  }
}
